<div>
  <p>{{ TranslationKeys.MultihomingAccessPortalMessage | translate }}</p>
</div>
